import { inject, Service, signal } from '@angular/core';

import { BaasActionButtonOptions } from '../../baas-action-button/baas-action-button.types';
import { BaasHeroOptions } from '../../baas-hero/baas-hero-options';
import { BaasLoadingOptions } from '../../baas-loading/baas-loading-options.type';
import { BaasMenuButtonItemOptions } from '../../baas-menu-button/baas-menu-button-item.types';
import { BaasExternalLinkGroupOptions } from '../baas-external-link-group-options.type';
import { _BaasInternalLayoutService } from '../baas-internal-layout.service';
import { BarAppMenuItem } from '../bar-app-menu-item.type';
import { BarMenuState } from '../bar-menu-state.type';
import { BaasMenuItemOptions } from './baas-layout-menu/baas-menu-item-options.type';

/** Public BaaS layout service */
@Service({ autoProvided: false })
export class BaasLayoutService {
    readonly #internalLayout = inject(_BaasInternalLayoutService);

    /** Whether the UI interceptor is enabled or disabled.  */
    interception = true;

    readonly title = signal<string>(undefined);
    readonly subTitle = signal<string>(undefined);
    readonly mainHeader = signal<string>(undefined);
    readonly sidebar = signal(undefined);
    readonly hero = signal<BaasHeroOptions>(undefined);
    readonly appMenuItems = signal<BarAppMenuItem[]>(undefined);
    readonly menuItems = signal<BaasMenuItemOptions[]>(undefined);
    readonly menuItemsAutoCollapse = signal(undefined);
    readonly menuState = signal<BarMenuState>(undefined);
    readonly externalLinkGroups = signal<BaasExternalLinkGroupOptions[]>(undefined);
    readonly strikingActions = signal<BaasActionButtonOptions[]>(undefined);
    readonly operations = signal<BaasActionButtonOptions[]>(undefined);
    readonly submitActions = signal<BaasActionButtonOptions[]>(undefined);
    readonly moreActions = signal<BaasMenuButtonItemOptions[]>(undefined);
    readonly contentActions = signal<BaasActionButtonOptions[]>(undefined);
    readonly mainAction = signal<BaasActionButtonOptions>(undefined);
    /** Loading overlay visible or not. This is used when the app is loaded, but when something is loading (e.g. network, http call). */
    readonly loading = signal(undefined);
    readonly loadingOptions = signal<BaasLoadingOptions>(undefined);
    /** Global app loading overlay visible or not. Only to be used in exceptional cases. The loader is mainly used to indicate that the entire app is loading. */
    readonly appLoading = signal(undefined);
    readonly compact = signal(undefined);
    readonly touch = signal(undefined);
    readonly mobileFriendly = signal<boolean>(undefined);
    readonly appVersion = signal<string>(undefined);
    /** @experimental Device type which can only be used in responsive layout modus. Otherwise the value remains undefined. */
    readonly deviceType = this.#internalLayout.deviceType.asReadonly();
}
